import { ChangeEvent } from "react";
import { TranslationService } from "../../../../services/TranslationService";
import { RequiredManager } from "../../../shared/RequieredManager";
import { CriterionModel, Operator } from "../../providers/CriteriaContext";
import Dropdown from "../../../shared/components/Dropdown";
import { MultiselectEditor } from "../../../shared/components/Editors";
import { InputWithValidation } from "./InputWithValidation";

type ActivityTypeCriterionProps = {
  data: CriterionModel;
  dateOperators: any[];
  listOperators: any[];
  activities: { label: string; value: string }[];
  activityTypes: string;
  inputResetKey: number;
  onOperatorChange: (value: number) => void;
  onValueChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onActivityOperatorChange: (value: number) => void;
  onActivityChange: (options: string[] | undefined) => void;
  requiredManager: RequiredManager;
};

export const ActivityTypeCriterion = ({
  data,
  dateOperators,
  listOperators,
  activities,
  activityTypes,
  inputResetKey,
  onOperatorChange,
  onValueChange,
  onActivityOperatorChange,
  onActivityChange,
  requiredManager
}: ActivityTypeCriterionProps) => {
  const { translate } = TranslationService;

  return (
    <>
      <Dropdown
        onChange={onOperatorChange}
        items={dateOperators}
        defaultValue={data.Operator}
      />
      {![Operator.Empty, Operator.NotEmpty].includes(data.Operator) && (
        <InputWithValidation
          inputResetKey={inputResetKey}
          type="number"
          item={data}
          filterKey="Value"
          callback={onValueChange}
          requiredManager={requiredManager}
          boxLeft={false}
          withBox={true}
          boxText={translate.Days}
        />
      )}
      <Dropdown
        onChange={onActivityOperatorChange}
        items={listOperators.slice(0, 2)}
        defaultValue={activityTypes.indexOf("!") > -1 ? 5 : 0}
      />
      <MultiselectEditor
        items={activities.sort((a, b) => a.label.localeCompare(b.label))}
        placeholder={translate.SelectActivityType}
        callback={onActivityChange}
        defaultValue={
          data.ActivityTypes
            ? activities.filter((x) =>
                data.ActivityTypes.split(",").includes(x.value)
              )
            : []
        }
        className="mw-250"
      />
    </>
  );
};
